import { render, staticRenderFns } from "./DeclarationRevenue.vue?vue&type=template&id=2f88a655&scoped=true&"
import script from "./DeclarationRevenue.vue?vue&type=script&lang=js&"
export * from "./DeclarationRevenue.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationRevenue.vue?vue&type=style&index=0&id=2f88a655&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f88a655",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
